(function ($) {
    "use strict";
    var $body = $("body"),
        $window = $(window),
        $bgBack = $(".bg-screen .bg-back"),
        $bgShop = $(".bg-screen .bg-shop"),
        $document = $(document);
        
    // menu toggler js
    var $toggler = $("a.toggler-btn"),
        $menu_close = $(".menu-close button.menu-close-btn, .bg-screen .bg-back"),
        $mobile_menu = $("#mobile-menu");
    $toggler.on("click", function() {
        $mobile_menu.removeClass("invisible").addClass("active visible");
        $bgBack.removeClass("opacity-0 invisible").addClass("opacity-50 visible");
        $body.addClass("mb-hidden");
    });
    $menu_close.on("click", function() {
        $mobile_menu.addClass("invisible").removeClass("active visible");
        $bgBack.addClass("opacity-0 invisible").removeClass("opacity-50 visible");
        $body.removeClass("mb-hidden");
    });

    // filter button js
    var $shopFilterBtn = $("button.shop-filter-btn"),
        $shopSidebarClose = $("button.shop-sidebar-close, .bg-screen .bg-back"),
        $shopFilterSidebar = $(".shop-filter-sidebar");
    $shopFilterBtn.on("click", function() {
        $shopFilterSidebar.addClass("active");
        $bgBack.removeClass("opacity-0 invisible").addClass("opacity-50 visible");
        $body.addClass("mb-hidden");
    });
    $shopSidebarClose.on("click", function() {
        $shopFilterSidebar.removeClass("active");
        $bgBack.addClass("opacity-0 invisible").removeClass("opacity-50 visible");
        $body.removeClass("mb-hidden");
    });

    // tooltip js
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    });

    // product-img full-view & magnific popup
    $('.zoom').on('click', function() {
        $('.product-img-big').magnificPopup({
            delegate: 'a',
            type:'image',
            showCloseBtn: true,
            closeBtnInside: false,
            midClick: true,
            tLoading: 'Loading image #%curr%...',
            mainClass: 'mfp-img-mobile',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1]
            }
        }).magnificPopup('open');
    });
    $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
        tClose: 'Close (Esc)',
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });
    $('.item-data').on("click", function() {
        $(this).parents('.option-block').find(".variant-option").removeClass('active-variant');
        $(this).closest('form-wrap').addClass('active-variant');
        var it_img = $(this).attr('dataimg');
        $(this).parents('.single-product-wrap').find('.product-image img.img1').attr('src',it_img);
        $(this).parents('.single-product-wrap').find('.product-image img.img1').attr('srcset',it_img);
        var price = $(this).attr('dataprice');
        var compareprice = $(this).attr('datacompare');
        var stocks = $(this).attr('dataavailable');
        $(this).parents('.single-product-wrap').find('.price-box .new-price').text(Shopify.formatMoney(price, window.money_format));
        if (compareprice > price) {
            $(this).parents('.single-product-wrap').find('.price-box .old-price').show();
            $(this).parents('.single-product-wrap').find('.price-box .old-price').html(Shopify.formatMoney(compareprice, window.money_format));
        }else{
            $(this).parents('.single-product-wrap').find('.price-box .old-price').hide();
        }
    });
})(jQuery);